import { Button } from '@material-tailwind/react'
import React, { useEffect } from 'react'
import { useFieldArray } from 'react-hook-form';
import AInput from '../../components/fields/AInput';
import APDate from '../../components/fields/APDate';
import ASelect from '../../components/fields/ASelect';
import AIcon from '../../components/partials/AIcon';
export default function ItemsComp({ v }) {
    const { fields, append, remove } = useFieldArray({
        control: v.control,
        name: v.items
    });

    const getOBJKeys = (obj) => obj ? Object.keys(obj) : null

    useEffect(() => {
        if (fields?.length === 0) appendFieldArrayData()
        //getColSize()
    }, [])

    const appendFieldArrayData = () => {
        append({ ...v?.data?.fields })
    }

    const getInputType = (f) =>( f === "price"||f === 'quantity') ? 'number' : 'text'
    const isRequired =(f)=>(f==="description")?false:'This field is required'

    const getError = (i, f) => {
        
        if (Object.keys(v.errors)?.length > 0) {
           console.log( v?.errors?.items)
            return  v?.errors?.items?v?.errors?.items[i][f]?.message: ''
        }
        // console.log( v?.errors?.items[i][f]);
    }

    return (
        <fieldset className={`border border-solid border-gray-300 px-2 py-1 rounded-md ${v.data?.className}`}>
            <legend className={`text-base text-black font-semibold amiriB ${v.className}`}>Items</legend>
            {fields.map((o, i) => {
                return (
                    <div className={`flex flex-wrap gap-2  border border-main-color rounded-md p-2 `} key={i} >
                        {getOBJKeys(v?.data?.fields)?.map((f, j) => {
                            return <div key={j} className=" flex-grow " >

                                {f === 'category' ? <ASelect v={{
                                    errors: v?.errors, control: v?.control,
                                    data: { label: v.data?.head[j], name: `items.${i}.${f}`, type: 'select', options: v?.data?.options, required: 'This field is required' }
                                }} />
                                    : f === 'from_date' || f === 'to_date' ? <APDate v={{
                                        errors: v?.errors, control: v?.control, setValue: v.setValue,
                                        data: { label: v.data?.head[j], name: `items.${i}.${f}`, type: 'date', required: 'This field is required' }
                                    }} />
                                        : <AInput v={{
                                            register: v?.register, errors: v?.errors, control: v?.control,
                                            data: { label: v.data?.head[j], name: `items.${i}.${f}`, type: getInputType(f), required: isRequired(f) }
                                        }} />

                                }

                                <small className="text-red-600">{getError(i, f)}</small>
                            </div>
                        })}
                        {i > 0 && <div className='w-[4%]' onClick={() => remove(i)}> <Button className='btn1 p-1 !bg-red-900 rounded-full'  ><AIcon name="close" size={15} /> </Button> </div>}

                    </div>
                )
            })}
            <Button variant="outlined" onClick={appendFieldArrayData} className='btn1 py-0.5 px-1  float-right mt-1 !bg-green-500  rounded-full'  ><AIcon name="add-circle-outline" size={20} className="text-white" /></Button>
        </fieldset>
    )
}

